module.exports = {
	"_args": [
		[
			{
				"raw": "proj4",
				"scope": null,
				"escapedName": "proj4",
				"name": "proj4",
				"rawSpec": "",
				"spec": "latest",
				"type": "tag"
			},
			"/Users/danidoriga/Documents/DANI/Coding/Web/barnatasa5"
		]
	],
	"_from": "proj4@latest",
	"_id": "proj4@2.4.4",
	"_inCache": true,
	"_location": "/proj4",
	"_nodeVersion": "8.2.1",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/proj4-2.4.4.tgz_1502418137878_0.6641639927402139"
	},
	"_npmUser": {
		"name": "ahocevar",
		"email": "andreas.hocevar@gmail.com"
	},
	"_npmVersion": "5.3.0",
	"_phantomChildren": {},
	"_requested": {
		"raw": "proj4",
		"scope": null,
		"escapedName": "proj4",
		"name": "proj4",
		"rawSpec": "",
		"spec": "latest",
		"type": "tag"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz",
	"_shasum": "c03d825e380f6850a4a7af5d20d365f6b72c4042",
	"_shrinkwrap": null,
	"_spec": "proj4",
	"_where": "/Users/danidoriga/Documents/DANI/Coding/Web/barnatasa5",
	"author": "",
	"bugs": {
		"url": "https://github.com/proj4js/proj4js/issues"
	},
	"contributors": [
		{
			"name": "Mike Adair",
			"email": "madair@dmsolutions.ca"
		},
		{
			"name": "Richard Greenwood",
			"email": "rich@greenwoodmap.com"
		},
		{
			"name": "Calvin Metcalf",
			"email": "calvin.metcalf@gmail.com"
		},
		{
			"name": "Richard Marsden",
			"url": "http://www.winwaed.com"
		},
		{
			"name": "T. Mittan"
		},
		{
			"name": "D. Steinwand"
		},
		{
			"name": "S. Nelson"
		}
	],
	"dependencies": {
		"mgrs": "1.0.0",
		"wkt-parser": "^1.2.0"
	},
	"description": "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",
	"devDependencies": {
		"chai": "~1.8.1",
		"curl": "git://github.com/cujojs/curl.git",
		"grunt": "^1.0.1",
		"grunt-cli": "~0.1.13",
		"grunt-contrib-connect": "~0.6.0",
		"grunt-contrib-jshint": "~1.1.0",
		"grunt-contrib-uglify": "~0.11.1",
		"grunt-mocha-phantomjs": "~0.4.0",
		"grunt-rollup": "^1.0.1",
		"istanbul": "~0.2.4",
		"mocha": "~1.17.1",
		"rollup": "^0.41.4",
		"rollup-plugin-json": "^2.0.1",
		"rollup-plugin-node-resolve": "^2.0.0",
		"tin": "~0.4.0"
	},
	"directories": {
		"test": "test",
		"doc": "docs"
	},
	"dist": {
		"integrity": "sha512-yo6qTpBQXnxhcPopKJeVwwOBRzUpEa3vzSFlr38f5mF4Jnfb6NOL/ePIomefWiZmPgkUblHpcwnWVMB8FS3GKw==",
		"shasum": "c03d825e380f6850a4a7af5d20d365f6b72c4042",
		"tarball": "https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz"
	},
	"gitHead": "e0fc90bb256d5b296c2ec9af923158d0fee847c5",
	"homepage": "https://github.com/proj4js/proj4js#readme",
	"license": "MIT",
	"main": "dist/proj4-src.js",
	"maintainers": [
		{
			"name": "cwmma",
			"email": "calvin.metcalf@gmail.com"
		},
		{
			"name": "ahocevar",
			"email": "andreas.hocevar@gmail.com"
		}
	],
	"module": "lib/index.js",
	"name": "proj4",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/proj4js/proj4js.git"
	},
	"scripts": {
		"build": "grunt",
		"build:tmerc": "grunt build:tmerc",
		"test": "npm run build && istanbul test _mocha test/test.js"
	},
	"version": "2.4.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/proj4/package.json
// module id = 1227
// module chunks = 0